import icon from './microsoft.svg';

import type { Provider } from '../providers'

export default {
    key: 'microsoft',
    fontKey: 'windows',
    name: 'Microsoft',
    color: '#00a1f1',
    icon
} satisfies Provider;
